import { useSegwayRouter } from '@/features/shared/hooks/useSegwayRouter'
import { useCallback } from 'react'
import { type SearchParams } from '@/features/shop/services/Search/types'
import { useOnUngatedCategories } from '@/features/shop/hooks/useOnUniversalCategories'
import { useValidSearchParams } from '@/features/shared/hooks/search'
import { stringifyWithCatIdsArray } from '@/features/shared/utils/queryString'
import { getRetailerFeaturedPromotionsUrl } from '@shared/constants/routes'
import { useIsPage } from '@/features/shared/hooks/useIsPage'
import { useUserStoreName } from '@/features/account/services/User/hooks'

export const useOnChangeFilter = () => {
  const router = useSegwayRouter()
  const ungatedPathname = useOnUngatedCategories() ?? ''
  const searchParams = useValidSearchParams()
  const storeName = useUserStoreName()
  const { RETAILER_FEATURED_PROMOTIONS } = useIsPage()
  const onChangeFilter = useCallback(
    (updatedParams: SearchParams) => {
      const { category_ids, ...queryParams } = searchParams
      const { zip, promotion_category_id } = queryParams
      const pathname = ungatedPathname || window.location.pathname
      const params = {
        ...queryParams,
        ...updatedParams,
        ...(ungatedPathname && zip && { zip }),
      }
      const stringifiedParams = stringifyWithCatIdsArray(params, JSON.stringify(category_ids))

      // featured promotion pages require a different path
      const route = RETAILER_FEATURED_PROMOTIONS
        ? `${getRetailerFeaturedPromotionsUrl(
            storeName,
            promotion_category_id ?? 0,
          )}?${stringifiedParams}`
        : `${pathname}?${stringifiedParams}`
      router.push(route, { shallow: true })
    },
    [ungatedPathname, searchParams, router, RETAILER_FEATURED_PROMOTIONS, storeName],
  )

  return { onChangeFilter }
}
